import { useState } from 'react';
import type { List } from '../db/types';
import { ColorSwatches } from './ColorSwatches';
import { Dialog } from './Dialog';

interface Props {
  initial?: Partial<List>;
  editing?: boolean;
  onSave: (patch: { name: string; color: string | null }) => void;
  onClose: () => void;
}

/** Name and colour. A list has nothing else worth asking about up front. */
export function ListDialog({ initial = {}, editing = false, onSave, onClose }: Props) {
  const [name, setName] = useState(initial.name ?? '');
  const [color, setColor] = useState<string | null>(initial.color ?? null);
  const clean = name.trim();

  return (
    <Dialog
      title={editing ? 'Edit list' : 'New list'}
      hint="Lists group work by where it happens. Tags cut across them."
      submitLabel={editing ? 'Save' : 'Create'}
      submitDisabled={clean.length === 0}
      onSubmit={() => onSave({ name: clean, color })}
      onClose={onClose}
    >
      <label className="dlg-field">
        <span className="dlg-field__label">Name</span>
        <input
          className="dlg-field__input"
          value={name}
          autoFocus
          spellCheck={false}
          placeholder="Work"
          onChange={(e) => setName(e.target.value)}
        />
      </label>

      <div className="dlg-field">
        <span className="dlg-field__label">Colour</span>
        <ColorSwatches value={color} onChange={setColor} />
        <span className="dlg-field__hint">
          Shows as the dot beside the list in the sidebar, and on rows that belong to it.
        </span>
      </div>
    </Dialog>
  );
}
